import { useCallback, useMemo } from 'react';
import { useQueryParams } from 'hooks/useQueryParams';
import {
  MembershipQueryParams,
  SupportPlan,
  MEMBERSHIP_URL_PARAM_KEYS,
} from '../../membership.types';
import { parseSupportQueryParams } from './useSupportUrlState.utils';

export type UseSupportUrlState = {
  plan?: SupportPlan;
  source?: string;
  setPlan: (plan: SupportPlan) => void;
};

export const useSupportUrlState = (): UseSupportUrlState => {
  const [params, setParams] = useQueryParams<MembershipQueryParams>();
  const parsedParams = useMemo(() => parseSupportQueryParams(params), [params]);

  const setPlan = useCallback(
    (plan: SupportPlan) => {
      setParams({
        ...params,
        [MEMBERSHIP_URL_PARAM_KEYS.plan]: plan,
      });
    },
    [params, setParams],
  );

  return {
    ...parsedParams,
    setPlan,
  };
};
